// Constants
import { FaqCategories, FaqQuestions } from "../constants/Faq";
// let FaqQuestions: any[] = [];
export interface FaqsProps {
    category: string;
    faqQuestions: any;
}

export interface FaqCateg {
    name: string;
    slug: string;
}
interface FaqCategsResponse {
    faqCategs: FaqCateg[] | null;
}

async function getAllCategories(): Promise<FaqCategsResponse> {
    return { faqCategs: FaqCategories };
}

interface GetFaqsParams {
    page?: number;
    limit?: number;
}
export interface FaqsResponse {
    faqs: FaqsProps[] | null;
    count: number;
}

interface FaqsByCategParams extends GetFaqsParams {
    categSlug: string;
}

async function getFaqsByCateg({ categSlug }: FaqsByCategParams): Promise<FaqsResponse> {
    const Faqs = FaqQuestions.filter((faqQuestion) => faqQuestion.category === categSlug);
    return { faqs: Faqs, count: Faqs[0]?.faqQuestions.length || 0 };
}

export const FaqService = { getAllCategories, getFaqsByCateg };
